import { render } from "./role-selection-modal.vue?vue&type=template&id=37e7b293&lang=pug"
import script from "./role-selection-modal.vue?vue&type=script&setup=true&lang=js"
export * from "./role-selection-modal.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__